import React, { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { api } from '@/utils/api';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card } from '@/components/ui/card';
import { toast } from 'sonner';
import { Lock } from 'lucide-react';

export default function ChangePasswordPage() {
  const { user, updateUser } = useAuth();
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newPassword.length < 6) {
      toast.error('A senha deve ter pelo menos 6 caracteres');
      return;
    }

    if (newPassword !== confirmPassword) {
      toast.error('As senhas nao coincidem');
      return;
    }

    setLoading(true);
    try {
      await api.changePassword(newPassword);
      toast.success('Senha alterada com sucesso!');
      updateUser({ must_change_password: false });
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erro ao alterar senha');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-8" style={{ background: 'linear-gradient(135deg, #0d4f4f 0%, #0a3d3d 40%, #063030 100%)' }}>
      <Card className="w-full max-w-md p-8 shadow-xl">
        <div className="flex flex-col items-center mb-8">
          <div className="w-16 h-16 rounded-xl bg-emerald-600 flex items-center justify-center mb-4">
            <span className="text-2xl font-bold text-white">B</span>
          </div>
          <h2 className="text-2xl font-bold text-slate-900 text-center" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Alterar Senha
          </h2>
          <p className="text-slate-600 text-center text-sm mt-2">
            Ola, {user?.name}! Por seguranca, crie uma nova senha para seu primeiro acesso.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5" data-testid="change-password-form">
          <div className="space-y-2">
            <Label htmlFor="new-password">Nova Senha</Label>
            <Input
              id="new-password"
              type="password"
              placeholder="Minimo 6 caracteres"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              data-testid="new-password-input"
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="confirm-password">Confirmar Nova Senha</Label>
            <Input
              id="confirm-password"
              type="password"
              placeholder="Repita a nova senha"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              data-testid="confirm-password-input"
            />
            {confirmPassword && newPassword !== confirmPassword && (
              <p className="text-xs text-red-500">As senhas nao coincidem</p>
            )}
          </div>

          <Button
            type="submit"
            className="w-full text-white"
            style={{ background: 'linear-gradient(135deg, #0d6b6b, #0a4f4f)' }}
            disabled={loading || !newPassword || !confirmPassword || newPassword !== confirmPassword}
            data-testid="change-password-button"
          >
            {loading ? 'Salvando...' : 'Salvar Nova Senha'}
          </Button>
        </form>
      </Card>
    </div>
  );
}
